module.exports = __webpack_public_path__ + "img/gigastore-lp-pos-mobile.40a7e3a4.png";